import { useLazyQuery } from "@apollo/client/react";import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomChip } from '../../../../components/chip/Chip';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import moment from 'moment';

import { GET_ESTADOS_HISTORIAL_EVOLUCION_ASISTENCIAL } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getHistorialRIEstados';
import { adaptHistorialRIArray, GET_HISTORIAL_EVOLUCION_ASISTENCIAL } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getHistorialRI';
import toast from 'react-hot-toast';
import { Outlet } from 'react-router-dom';

const estadosColor = {
  1: { isGreen: true },
  2: { isGreen: true },
  3: { isRed: true }
};

const EvolucionAsistHistorial = ({
  idEvaluacion
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [estados, setEstados] = useState([]);
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    if (!estadosLoading)
    getEstados();
  }, []);

  const getEstado = (idEstado) => {
    const color = estadosColor[idEstado];
    const estadoName = !estados ? '' : estados?.find((x) => x.idEstado === idEstado)?.nombre;
    return (
      <CustomChip
        label={estadoName}
        {...color}
        sx={{ marginLeft: '10px', fontSize: '12px' }} />);


  };

  const handleModalOpen = () => {
    getHistorial({ variables: { idEvaluacion: idEvaluacion } });
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const [getEstados, { data: dataEstados, loading: estadosLoading }] = useLazyQuery(GET_ESTADOS_HISTORIAL_EVOLUCION_ASISTENCIAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEstados) return;
    setEstados(dataEstados.allHistorialRIEstado);
  }, [dataEstados]);

  const [getHistorial, { data: dataHistorial, loading: isLoading }] = useLazyQuery(GET_HISTORIAL_EVOLUCION_ASISTENCIAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataHistorial) return;
    if (!dataHistorial?.historialRIById) return toast.error('No se pudo cargar la información del historial, intentelo nuevamente más tarde.');
    setHistorial(adaptHistorialRIArray(dataHistorial?.historialRIById));
  }, [dataHistorial]);

  return (
    <>
        <Box sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginTop: '18px'
      }}>
            <CustomButton
          label='Historial'
          variant='outlined'
          color='primary'
          onClick={handleModalOpen}
          endIcon={<HistoryRoundedIcon />} />
        

            <CustomDialog
          open={modalOpen}
          title={'Historial'}
          cancelText='Cerrar'
          onCancel={handleModalClose}
          fullWidth
          id='evolucion-asistencial-historial-dialog'
          maxWidth="md">
          
                <Timeline className="lineTime">
                    {!isLoading && historial.length > 0 && historial.map((evento, index) => {
              const isLast = index === historial.length - 1;
              return <Fragment key={`id-historial${evento.id}-index-${index}`}>
                            <TimelineItem>
                                <TimelineOppositeContent className="leftContent">
                                    <span className="date">
                                        <CalendarTodayIcon className="iconCalendar" />
                                        <div className='fecha-realizacion'>{!!evento.fechaRealizacion ? moment(evento.fechaRealizacion).format("DD/MM/YYYY HH:mm") : '-'}</div>
                                    </span>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot sx={{
                      width: '4px',
                      height: '4px',
                      bgcolor: '#0063BE',
                      border: '3px solid #B9D1EB',
                      borderRadius: '50%'
                    }} />
                                    {!isLast && <TimelineConnector sx={{ bgcolor: '#B9D1EB', border: '3px' }} />}
                                </TimelineSeparator>
                                <TimelineContent className="rightContent">
                                    <Accordion className='card-contenido-detalle' defaultExpanded>
                                        <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header">
                        
                                            <div className="titulo-evento-historial"><strong>{evento?.evento} </strong></div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="estadoHistorial"><strong>Usuario: </strong><span style={{ marginLeft: 5 }}>{evento.usuario}</span></div>
                                            <div className="estadoHistorial"><strong>Estado: </strong>{getEstado(evento.idEstado)}</div>
                                            {!!evento.descripcion && <div className="estadoHistorial" style={{ display: 'table-cell', verticalAlign: 'top' }}><strong>Motivo: </strong><label className='motivo-rechazo-descripcion' style={{ marginLeft: 5 }}>{evento.descripcion}</label></div>}
                                        </AccordionDetails>
                                    </Accordion>
                                </TimelineContent>
                            </TimelineItem>
                        </Fragment>;
            })
            }
                    {!historial.length && !isLoading &&
            <label>Todavía no se realizó ningún evento para este contrato...</label>
            }
                </Timeline>
            </CustomDialog>
        </Box>
        <Outlet />
        </>);

};

export default EvolucionAsistHistorial;

const historialmock = [
{
  id: 1,
  evento: 'Notificación Asistencial',
  fechaRealizacion: '2023-10-01T12:00:00Z',
  idEstado: 1,
  descripcion: 'Descripción de la evento 1',
  usuario: 'Samir Díaz'
},
{
  id: 2,
  evento: 'Asignacion profesional',
  fechaRealizacion: '2023-10-02T15:00:00Z',
  idEstado: 2,
  usuario: 'Samir Díaz'
},
{
  id: 3,
  evento: 'Cierre de RI',
  fechaRealizacion: '2023-10-03T19:00:00Z',
  idEstado: 3,
  usuario: 'Samir Díaz'
},
{
  id: 4,
  evento: 'Validación de RI',
  fechaRealizacion: '2023-10-01T12:00:00Z',
  idEstado: 1,
  descripcion: 'OK',
  usuario: 'Samir Díaz'
}];